module.exports = __webpack_public_path__ + "static/media/animal-care.9433742d.jpg";